import md5 from 'md5';
import React from 'react';
import { DEBUG_MODE_ENABLED } from '@/utils/constants';
import stringToColor from '@/utils/stringToColor';

export const useLog = ({ context = '' }) => {
  const hashedContext = React.useMemo(() => md5(context), [context]);

  return React.useRef((...args: [any?, ...any[]]) => {
    if (!DEBUG_MODE_ENABLED) return;

    console.log.apply(null, [
      `%c:: LOG [%c ${context} %c]`,
      'color: gray',
      `color: ${stringToColor(hashedContext)}; background: black`,
      'color: gray',
      ...args,
    ]);
  }).current;
};
